module.exports = __webpack_public_path__ + "img/login-right-image.6edd0835.svg";